module.exports = __webpack_public_path__ + "static/media/ordering-showcase-poster.6f83938b.png";